// Make this a no-op on the server side so including it as a dependency doesn't break things
// Check jQuery.fn.extend as well as jQuery to make sure the sham in typeahead.bundle.js doesn't pass the test.
// That sham also is of type "object" instead of type "function" like the real jQuery,
// so the second check should be redundant, but it doesn't hurt.
if (typeof jQuery === 'function' && jQuery.fn.extend) {
    /* global jQuery */
    jQuery.fn.extend({
        /**
         * @param {string} events Space-delimited list of events that must _all_ be triggered before the callback is called.
         * These should probably be events that only happen once, although that isn't technically required.
         *
         * @param {function} callback Callback that's triggered once all the events have happened.
         * If any of the listed events are triggered multiple times, and all other events were already triggered,
         * this callback could be called multiple times
         *
         * @return {object} The jQuery object
         */
        onAll: function (events, callback) {
            const triggeredEvents = {};
            const eventList = events.split(' ');

            function allTriggered() {
                return eventList.every(function (eventName) {
                    return triggeredEvents[eventName];
                });
            }

            const eventHandlers = {};
            eventList.forEach(function (eventName) {
                eventHandlers[eventName] = function () {
                    triggeredEvents[eventName] = true;
                    if (allTriggered()) {
                        callback();
                    }
                };
            });

            return this.on(eventHandlers);
        },
    });
}
